define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-attr",
	"dojo/keys",
	"dojo/on",
	"dojo/sniff",
	"dijit/focus",
	"dijit/form/_TextBoxMixin",
	"dijit/form/FilteringSelect",
	"dijit/form/TextBox",
	"csi/html",
	"csi/locale",
	"csi/service/sessionService",
	"csi/store/common",
	"./_ComboBoxMixin",
	"./_ErrorMessageMixin",
	"./_HasDropDownMixin"
], function(declare, lang, domAttr, keys, on, has, focus, _TextBoxMixin, FilteringSelect, TextBox, html, locale, { isAutoCompleteEnabled }, {DISABLED_PROPERTY}, _ComboBoxMixin, _ErrorMessageMixin, _HasDropDownMixin) {

	// DOJO_INTERNAL

	return declare([FilteringSelect, _ComboBoxMixin, _ErrorMessageMixin, _HasDropDownMixin], {
		// String: value to restore when widget goes invalid
		//_csiResetValue: null,

		/** @property {boolean} bClickNewAction - indicates if the user clicks the New Action if any */
		bClickNewAction: false,

		/** @property {TextBox} extraTextBox - in drop down filter text box*/
		extraTextBox: null,

		/** @property {HTMLElement} extraTextBoxDiv - div wrapper for extraTextBox */
		extraTextBoxDiv: null,

		// when filter value produce no results in dropdown we usually just close the dropdown but editor of combo box still visible and active
		// in case of "..InDropdown" component we can't close dropdown when there are no results, because editor located inside this dropdown
		dontCloseNoResults: true,

		csiResetValue: function(/*Any?*/resetValue) {
			// summary: reset to last known good value
			var v = resetValue || this._csiResetValue || this._resetValue;
			if (v && (v != this.get("value"))) {
				this.set("value", v, false);

				// FIX: should we use below instead from _AutoCompleterMixin::_setBlurValue?
				//this._setValueAttr(v, true);
			}
		},

		hasActionsWithoutAutocomplete: function() {
			// summary: check if autoComplete is off and store action data exists
			return !this.get("autoComplete") && this.store.actionData && this.store.actionData.length;
		},

		reinitializeValue: function(/*Any*/value) {
			// summary: set initial value of widget after its creation - dijit widgets work on assumption that onChange should
			// be called on any value change after creation, but in some cases it is not possible to set initial value until later.
			this._resetValue = this._lastValueReported = value;
			this.set("value", value, null);
		},

		_processInput: function(/*Event*/ evt) {
			// summary: (C8-19391) fix error when allow to compare type string to integer when comparing key "8" (number "eight") with key 8 (escape)
			// this code fixes dojo bug from dijit/form/_SearchMixin->_processInput()
			if (this.disabled || this.readOnly) {
				return;
			}
			// preserve value before calling inherited
			var _maskValidSubsetError = this._maskValidSubsetError;

			this.inherited(arguments);

			var key = evt.charOrCode;

			// reset to false - same as in inherited
			this._prev_key_backspace = false;
			// restore saved value before properly re-done comparison
			this._maskValidSubsetError = _maskValidSubsetError;

			// this is real fix: use "===" instead of "=="
			if (key === keys.DELETE || key === keys.BACKSPACE) {
				this._prev_key_backspace = true;
				this._maskValidSubsetError = true;
			}

		},

		_handleOnChange: function(/*anything*/newValue, /*Boolean?*/priorityChange) {
			// summary: track last valid change
			this.inherited(arguments);

			if (this.item) {
				if (this.textbox) {
					this.textbox.title = this.item.name || this.item.Name;
				}
				this._csiResetValue = newValue;
			}

			this.extraTextBox?._updatePlaceHolder();
		},

		_onFocus: function(/*String*/by) {
			// summary: only open drop-down and select text when triggered by mouse and widget is still in focus (C8-3316)
			this.inherited(arguments);

			this.defer(function() {
				if (this.focusNode == focus.curNode) {
					if (by == 'mouse') {
						this.toggleDropDown();
					}

					_TextBoxMixin.selectInputText(this.focusNode);
				}
			});
		},

		_onDropDownMouseDown: function(/*Event*/ e) {
			// summary: make sure widget in focus when clicking drop-down button (Ticket #13790)
			if (this.disabled || this.readOnly) return;
			this.inherited(arguments);
			this.focus();
			var focusNode = this.focusNode;
			this.defer(function() {
				_TextBoxMixin.selectInputText(focusNode);
			});
		},

		_onKey: function(/*Event*/e) {
			// summary: restore value if escape pressed

			// tab events while inline editing seem to come through after the widget is destroyed in IE, so add check here
			// to make sure widget still exists
			if (!html.exists(this)) {
				return;
			}

			// if ENTER or TAB key pressed and preventDefault called, then do nothing
			const {keyCode} = e;

			if (e.defaultPrevented && (keyCode === keys.TAB || keyCode === keys.ENTER)) {
				return;
			}

			this.inherited(arguments);

			if ((keyCode == keys.ESCAPE) && !e.cancelBubble) {
				this.csiResetValue();

				// Firefox will abort active request without below statement - we want request to continue so that
				// results can be reused for next query
				e.preventDefault();
			}
		},

		_setBlurValue: function() {
			// summary: restore last valid value if blurred with invalid value
			// FIX: this should be optional - if in form, should we just leave invalid values alone?
			var resetValue = this._csiResetValue;
			// set fetchProperties to noActionData as query option so goToDialog or any other action is not triggered on blur
			this.fetchProperties = this.fetchProperties || {};
			this.fetchProperties.noActionData = true;

			// set back to undefined if needed to make sure restore the valid value when user type in invalid value
			this.item = (this.item && Object.keys(this.item).length < 1) ? undefined : this.item;

			this.inherited(arguments);

			delete this.fetchProperties.noActionData;

			if (!this.item || this.item[DISABLED_PROPERTY]) {
				this.csiResetValue(resetValue);
			}
		},

		/**
		 * @override
		 * This function should not include action data when querying store
		 */
		_setDisplayedValueAttr(label, priorityChange) {
			this.fetchProperties = this.fetchProperties || {};
			this.fetchProperties.noActionData = true;
			this.inherited(arguments);
			delete this.fetchProperties.noActionData;
		},

		/**
		 * Override to set the autoComplete property if needed
		 */
		postCreate: function() {
			// in other countries, like China, Japan etc., when user input a word, they have to input several English letters before they can get
			// the actual word, So, don't need to autoComplete
			this.autoComplete = isAutoCompleteEnabled();

			this.domNode.className += " csi-filter-in-dropdown";
			this._startSearch("");

			this.inherited(arguments);
		},

		/**
		 * overrides to make sure the validate doesn't happen when the query completes
		 * @param {Object} results
		 * @param {Object} query
		 * @param {Object} options
		 */
		_openResultList: function(results, query, options) {
			this.item = (this.item == undefined) ? {} : this.item;
			this.inherited(arguments);
		},

		// Code below is different from original FilteringSelect

		createNewTextBox: function() {
			// function handleEvent() is clone of dojo code form\_TextBoxMixin.js-> postCreate()
			// copied here to support new TextBox
			// begin of dojo code
			function handleEvent(e) {
				var charOrCode;

				// Filter out keydown events that will be followed by keypress events.  Note that chrome/android
				// w/word suggestion has keydown/229 events on typing with no corresponding keypress events.
				if (e.type == "keydown" && e.keyCode != 229) {
					charOrCode = e.keyCode;
					switch (charOrCode) { // ignore state keys
						case keys.SHIFT:
						case keys.ALT:
						case keys.CTRL:
						case keys.META:
						case keys.CAPS_LOCK:
						case keys.NUM_LOCK:
						case keys.SCROLL_LOCK:
							return;
					}
					if (!e.ctrlKey && !e.metaKey && !e.altKey) { // no modifiers
						switch (charOrCode) { // ignore location keys
							case keys.NUMPAD_0:
							case keys.NUMPAD_1:
							case keys.NUMPAD_2:
							case keys.NUMPAD_3:
							case keys.NUMPAD_4:
							case keys.NUMPAD_5:
							case keys.NUMPAD_6:
							case keys.NUMPAD_7:
							case keys.NUMPAD_8:
							case keys.NUMPAD_9:
							case keys.NUMPAD_MULTIPLY:
							case keys.NUMPAD_PLUS:
							case keys.NUMPAD_ENTER:
							case keys.NUMPAD_MINUS:
							case keys.NUMPAD_PERIOD:
							case keys.NUMPAD_DIVIDE:
								return;
						}
						if ((charOrCode >= 65 && charOrCode <= 90) || (charOrCode >= 48 && charOrCode <= 57) || charOrCode == keys.SPACE) {
							return; // keypress will handle simple non-modified printable keys
						}
						var named = false;
						for (var i in keys) {
							if (keys[i] === e.keyCode) {
								named = true;
								break;
							}
						}
						if (!named) {
							return;
						} // only allow named ones through
					}
				}

				charOrCode = e.charCode >= 32 ? String.fromCharCode(e.charCode) : e.charCode;
				if (!charOrCode) {
					charOrCode = (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode == keys.SPACE ? String.fromCharCode(e.keyCode) : e.keyCode;
				}
				if (!charOrCode) {
					charOrCode = 229; // IME
				}
				if (e.type == "keypress") {
					if (typeof charOrCode != "string") {
						return;
					}
					if ((charOrCode >= 'a' && charOrCode <= 'z') || (charOrCode >= 'A' && charOrCode <= 'Z') || (charOrCode >= '0' && charOrCode <= '9') || (charOrCode === ' ')) {
						if (e.ctrlKey || e.metaKey || e.altKey) {
							return;
						} // can only be stopped reliably in keydown
					}
				}

				// create fake event to set charOrCode and to know if preventDefault() was called
				var faux = {faux: true}, attr;
				for (attr in e) {
					if (!/^(layer[XY]|returnValue|keyLocation)$/.test(attr)) { // prevent WebKit warnings
						var v = e[attr];
						if (typeof v != "function" && typeof v != "undefined") {
							faux[attr] = v;
						}
					}
				}
				lang.mixin(faux, {
					charOrCode: charOrCode,
					_wasConsumed: false,
					preventDefault: function() {
						faux._wasConsumed = true;
						e.preventDefault();
					},
					stopPropagation: function() {
						e.stopPropagation();
					}
				});

				this._lastInputProducingEvent = faux;

				// Give web page author a chance to consume the event.  Note that onInput() may be called multiple times
				// for same keystroke: once for keypress event and once for input event.
				//console.log(faux.type + ', charOrCode = (' + (typeof charOrCode) + ') ' + charOrCode + ', ctrl ' + !!faux.ctrlKey + ', alt ' + !!faux.altKey + ', meta ' + !!faux.metaKey + ', shift ' + !!faux.shiftKey);
				if (this.onInput(faux) === false) { // return false means stop
					faux.preventDefault();
					faux.stopPropagation();
				}
				if (faux._wasConsumed) {
					return;
				} // if preventDefault was called

				// IE8 doesn't emit the "input" event at all, and IE9 doesn't emit it for backspace, delete, cut, etc.
				// Since the code below (and perhaps user code) depends on that event, emit it synthetically.
				// See http://benalpert.com/2013/06/18/a-near-perfect-oninput-shim-for-ie-8-and-9.html.
				if (has("ie") <= 9) {
					switch (e.keyCode) {
						case keys.TAB:
						case keys.ESCAPE:
						case keys.DOWN_ARROW:
						case keys.UP_ARROW:
						case keys.LEFT_ARROW:
						case keys.RIGHT_ARROW:
							// These keys may alter the <input>'s value indirectly, but we don't want to emit an "input"
							// event.  For example, the up/down arrows in TimeTextBox or ComboBox will cause the next
							// dropdown item's value to be copied to the <input>.
							break;
						default:
							if (e.keyCode == keys.ENTER && this.textbox.tagName.toLowerCase() != "textarea") {
								break;
							}
							this.defer(function() {
								if (this.textbox.value !== this._lastInputEventValue) {
									on.emit(this.textbox, "input", {bubbles: true});
								}
							});
					}
				}
			} // end of dojo code

			this.extraTextBox = new TextBox({
				placeHolder: locale.resource("TypeKeywordToFilter"),
				class: "csi-filter-in-dropdown-textbox",
			})

			this.focusNode = this.extraTextBox.focusNode;
			this.textbox = this.extraTextBox.textbox;

			this.own(
				on(this.textbox, "keydown, keypress, paste, cut", lang.hitch(this, handleEvent)),
				on(this.textbox, "input", lang.hitch(this, "_onInput")),

				// compositionstart would happen when start typing with IME open
				on(this.textbox, "compositionstart", () => {
					this.textbox.isDoneComposition = false;
					this.textbox.isComposisiton = true;
				}),

				// compositionend would happen after picking the word from IME
				on(this.textbox, "compositionend", () => {
					this.textbox.isDoneComposition = true;
					this.textbox.isComposisiton = false;
				}),
				 
				on(this.textbox, "keypress", function(e) {e.stopPropagation();}),
				on(this.textbox, "keydown", lang.hitch(this, "_onKey")),
				on(this.textbox, "keyup", lang.hitch(this, "_onKeyUp")),
			);
		},

		// Create new TextBox for filtering
		openDropDown: function() {
			this.inherited(arguments);

			// drop down scroll node
			const refNode = this.dropDown.domNode.parentElement;
			// calculate if dropdown is opened down or up
			const comboTop = this.domNode.getBoundingClientRect().top;
			const dropDownTop = refNode.getBoundingClientRect().top;
			const bUp = dropDownTop < comboTop;
			// create textbox inside dropdown if needed
			if (!this.extraTextBoxDiv) {
				this.createNewTextBox();
				this.extraTextBox.placeAt(
					this.extraTextBoxDiv = html.create("div", {class: "csi-filter-in-dropdown-container" + (bUp ? " csi-dropdown-up" : "")})
				);
			}
			// dropdown has fixed top position, but we are going to add text editor to dropdown which can make it taller and potentially dropdown
			// bottom edge can cover original control. We need to adjust dropdown top position to maintain dropdown position above control
			// dropdown might have vertical scroll and height increase might be less then added control's height, so we measure dropdown height 
			// before and after insertion and calculating difference, to move dropdown up for this difference
			// height before:
			const DropDownHeightBefore = refNode.offsetHeight;
			// insert
			refNode.insertBefore(this.extraTextBoxDiv, bUp ? null : refNode.firstChild);
			// if dropdown positioned upward, we need to correct its top position
			if (bUp) {
				// height after insert
				const DropDownHeightAfter = refNode.offsetHeight;
				// added height
				const addedHeight = DropDownHeightAfter - DropDownHeightBefore;
				// correct top position
				refNode.style.top = refNode.offsetTop - addedHeight + "px";
			}
			this.extraTextBoxDiv.style.display = "";
			this.extraTextBox.focus();
		},

		// preserve created TextBox by attaching it to hidden domNode (domNode width = 0)
		closeDropDown: function() {
			if (this.extraTextBoxDiv) {
				this.domNode.append(this.extraTextBoxDiv);
				this.extraTextBoxDiv.style.display = "none";
			}
			this.domNode.style.display = "";

			this.inherited(arguments);
		},

		onSelect: function() {
			// extension point
		},

		_selectOption: function(/*DomNode*/ target) {
			this.inherited(arguments);
			this.onSelect();
		}

	});
});